import ContainerConfig from './container/ContainerConfig'
import { deepMerge } from './utils'
/**
 * Class describing the config response from the server,
 * which includes enabled bidders and config for the enabled zone(s)
 * {
 *      container: 'DOCKED',
 *      selector: 'img .ads',
 *      prebid: {...} pbjs config
 * }
 */

export default class {
  constructor (zoneId, cfg) {
    this._zoneId = zoneId
    this._cfg = deepMerge({
      prebid_opts: {},
      pixels: [],
      alt_sizes: true,
      content_url: null,
      refresh: 60
    }, cfg)

    this._container = new ContainerConfig(this._cfg.container)
  }

  /**
   * @returns zone id
   */
  zoneId (zoneId) {
    if (zoneId === undefined) {
      return this._zoneId
    }

    this._zoneId = zoneId
  }

  /**
     * @returns A ContainerConfig instance
     */
  container () {
    return this._container
  }

  /**
     * @returns PrebidJS generated config
     */
  prebidOpts () {
    return this._cfg.prebid_opts
  }

  bidders () {
    return this._cfg.bidders
  }

  media () {
    return this._cfg.media
  }

  altSizes () {
    return this._cfg.alt_sizes === true
  }

  /**
   * List of optional third party pixels to fire during clear event
   * @returns {array}
   */
  pixels () {
    return this._cfg.pixels
  }

  /**
   * Returns a file/mp4 content URL to use as instream video player content if configured
   * @returns {string} content url
   */
  contentUrl () {
    return this._cfg.content_url
  }

  /**
   * Refresh interval in seconds if non zero
   */
  refresh () {
    return this._cfg.refresh
  }

  /**
   * Optional custom CSS to append to page
   * @returns {string} css content
   */
  style (style) {
    if (style) {
      this._cfg.style = style
    } else {
      return this._cfg.style
    }
  }
}
